import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../../hooks/useMainContext';
import { AiOutlineExpandAlt } from 'react-icons/ai';
import { DeleteIconSm, EditIcon } from '../../Globle/Icon';

const UnitCollapseHeader = observer(
    ({ unit, handleFitToScreen, handleEdit, handleDelete }) => {
        const { viewManager } = useMainContext();
        const isVisible = viewManager.doUserHasAccess();
        return (
            <div className="h-[40px] flex items-center justify-between">
                <div className="flex items-center gap-[8px]">
                    <h1 className="font-favorit text-[14px] font-[700] leading-[21px]">
                        {unit._name}
                    </h1>
                    <div className="w-[1px] h-[21px] bg-theme-border"></div>
                    <p className="font-favorit text-[14px] font-[400] leading-[21px] text-theme-stroke">
                        {unit.page.name}
                    </p>
                </div>
                <div className="flex gap-[8px] items-center">
                    <div
                        className="cursor-pointer"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleFitToScreen();
                        }}>
                        <AiOutlineExpandAlt className="text-[20px]" />
                    </div>
                    {isVisible && (
                        <div
                            className="cursor-pointer"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleEdit();
                            }}>
                            <EditIcon />
                        </div>
                    )}
                    {isVisible && (
                        <div
                            className="cursor-pointer"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleDelete();
                            }}>
                            <DeleteIconSm />
                        </div>
                    )}
                </div>
            </div>
        );
    },
);
export default UnitCollapseHeader;
